import React from 'react'
import PropTypes from 'propTypes'
import styles from './styles'

const Body = ({ children }) => <main className={styles.wrapper}>{children}</main>

Body.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

export default Body
